module.exports = __webpack_public_path__ + "9fcbff3c27e83ac6617ef9b5a525e18d.png";